import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';

const navItems = [
  { path: '/', label: 'Dashboard', icon: '📊' },
  { path: '/bot-config', label: 'Bot Config', icon: '🤖' },
  { path: '/scripts', label: 'Script Editor', icon: '📝' },
  { path: '/server', label: 'Server Settings', icon: '⚙️' },
  { path: '/profiles', label: 'Profiles', icon: '👤' },
  { path: '/mystic-bots', label: 'Mystic Bots', icon: '🔮' },
];

function Layout({ children }) {
  return (
    <div className="app-container">
      <aside className="sidebar">
        <div className="sidebar-header">
          <h1>L2Walker</h1>
          <span>Web Control Panel v1.0</span>
        </div>
        <nav className="sidebar-nav">
          {navItems.map(item => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
            >
              <span className="nav-icon">{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
        </nav>
      </aside>
      <main className="main-content">
        {children}
      </main>
    </div>
  );
}

export default Layout;
